import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CampSiege4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CAMP_SIEGE4;
}

export default CampSiege4PoiTileEntity;
